export enum PlatformResourceType {
    Projects = 'projects',
    Organizations = 'organizations',
    Users = 'users',
    Memberships = 'memberships',
    Rules = 'rules',
    Keys = 'keys',
    Platforms = 'platforms',
    Webhooks = 'webhooks',
    Certificates = 'certificates',
}
